import CampaignLeadsCard from './CampaignLeadsCard'
import ConversionRateCard from './ConversionRateCard'
import OrdersClosedCard from './OrdersClosedCard'
import OrdersLostCard from './OrdersLostCard'
import TargetAchievementCard from './TargetAchievementCard'

export default function DashboardStats({
  campaignLeads,
  conversionRate,
  ordersClosed,
  ordersLost,
  target,
  achievement,
  period,
  customRange,
}) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      <CampaignLeadsCard
        data={campaignLeads}
        period={period}
        customRange={customRange}
      />
      <ConversionRateCard
        data={conversionRate}
        period={period}
        customRange={customRange}
      />
      <TargetAchievementCard
        target={target}
        achievement={achievement ?? ordersClosed?.total ?? 0}
        achievementRevenue={ordersClosed?.revenue ?? 0}
        isTeam={false}
        period={period}
        customRange={customRange}
      />
      <OrdersClosedCard
        data={ordersClosed}
        period={period}
        customRange={customRange}
      />
      <OrdersLostCard
        data={ordersLost}
        period={period}
        customRange={customRange}
      />
    </section>
  )
}
